import { OPTIMIZER_RIGHT_BLOCK_WRAPPER_ID } from './brief/KeywordsBriefWrapper';

/**
 * Gets the optimizer right block wrapper element.
 * @returns {HTMLElement} - The optimizer right block wrapper element.
 */
export const getOptimizerRightBlockWrapper = () =>
    document.getElementById(OPTIMIZER_RIGHT_BLOCK_WRAPPER_ID);

export const getKeywordActionText = (isCustom = false, isRemoved = false, lowercased = false) => {
    let actionText = !isCustom ? (!isRemoved ? 'Ignore' : 'Restore') : 'Delete';

    if (lowercased) {
        actionText = actionText.toLowerCase();
    }

    return actionText;
};
